import axios from 'axios';
import Cookies from 'js-cookie';

// Configuração base da API - usa variável de ambiente em desenvolvimento, produção hardcoded
const getBaseURL = () => {
  // Se estiver rodando localmente (localhost ou 127.0.0.1)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
  }
  // Produção - URL hardcoded
  return 'https://api.ibe.elshadaysystems.com.br/api';
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('🔗 API URL:', api.defaults.baseURL);
console.log('🌍 Ambiente:', window.location.hostname === 'localhost' ? 'DESENVOLVIMENTO' : 'PRODUÇÃO');


// Variável para controlar se já está fazendo refresh
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Interceptador de requisições
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('auth_token') || localStorage.getItem('auth_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
   
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptador de respostas
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Se erro 401 e não é uma tentativa de refresh ou login
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/auth/login')) {
      
      if (isRefreshing) {
        // Se já está fazendo refresh, adiciona à fila
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const token = Cookies.get('auth_token') || localStorage.getItem('auth_token');

      if (token) {
        try {
          const refreshUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
            ? 'http://localhost:3001/api/auth/refresh'
            : 'https://api.ibe.elshadaysystems.com.br/api/auth/refresh';
          
          const response = await axios.post(
            refreshUrl,
            {},
            {
              headers: { Authorization: `Bearer ${token}` }
            }
          );

          const { token: newToken } = response.data;
          
          // Salvar novo token
          Cookies.set('auth_token', newToken, { expires: 1, secure: true, sameSite: 'strict' });
          localStorage.setItem('auth_token', newToken);
          
          // Atualizar header
          api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
          
          processQueue(null, newToken);
          
          // Retry da requisição original
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);

        } catch (refreshError) {
          processQueue(refreshError, null);
          
          // Limpar tokens
          Cookies.remove('auth_token');
          localStorage.removeItem('auth_token');
          delete api.defaults.headers.common['Authorization'];
          
          // Redirecionar para login
          window.location.href = '/login';
          
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      } else {
        isRefreshing = false;
        processQueue(error, null);
        
        // Redirecionar para login se não há token
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
